import React, { useState, useEffect } from "react";
import UnidadeGrafico from "./UnidadeGrafico";
import "../../styles/dashboardStyle/CardUnidades.css";
import { UnidadesDashboard, IntervalDataItem } from "../../API/dashboardDetailsService";

interface CardUnidadesProps {
  planoUsuario: "casa_apartamento" | "comercial" | "lote" | "compacto";
  unidadesData: UnidadesDashboard;
}

export default function CardUnidades({ planoUsuario, unidadesData }: CardUnidadesProps) {
  const [dropdownValue, setDropdownValue] = useState<"tipologia" | "area" | "cidades">("tipologia");
  const [dadosAtuais, setDadosAtuais] = useState<{
    ofertadas: IntervalDataItem[];
    vendidas: IntervalDataItem[];
    estoque: IntervalDataItem[];
  }>({
    ofertadas: [],
    vendidas: [],
    estoque: [],
  });

  const converterDados = (dados: Record<string, number>): IntervalDataItem[] =>
    Object.entries(dados).map(([intervalo, quantidade]) => ({ intervalo, quantidade: Number(quantidade) }));

  const tipologiaDisponiveis = (plano: string) => {
    if (plano === "casa_apartamento") return ["1Q", "2Q", "3Q", "4Q+"];
    if (plano === "comercial") return ["Sala", "Loja", "Galpão", "Lote Comercial"];
    return [];
  };

  useEffect(() => {
    let dados: {
      ofertadas: IntervalDataItem[];
      vendidas: IntervalDataItem[];
      estoque: IntervalDataItem[];
    } = { ofertadas: [], vendidas: [], estoque: [] };

    switch (dropdownValue) {
      case "tipologia":
        const tipologias = tipologiaDisponiveis(planoUsuario);
        if (tipologias.length === 0) break;
        dados = {
          ofertadas: converterDados(unidadesData.tipologia.ofertadas),
          vendidas: converterDados(unidadesData.tipologia.vendidas),
          estoque: converterDados(unidadesData.tipologia.estoque),
        };
        break;
      case "area":
        dados = {
          ofertadas: converterDados(unidadesData.area.ofertadas),
          vendidas: converterDados(unidadesData.area.vendidas),
          estoque: converterDados(unidadesData.area.estoque),
        };
        break;
      case "cidades":
        dados = {
          ofertadas: converterDados(unidadesData.cidades.ofertadas),
          vendidas: converterDados(unidadesData.cidades.vendidas),
          estoque: converterDados(unidadesData.cidades.estoque),
        };
        break;
    }

    setDadosAtuais(dados);
  }, [dropdownValue, unidadesData, planoUsuario]);

  return (
    <div className="card-unidades">
      <div className="card-header">
        <h3>Unidades</h3>
        <select
          className="filtro-select"
          value={dropdownValue}
          onChange={(e) => setDropdownValue(e.target.value as any)}
        >
          {dropdownValue !== "tipologia" || tipologiaDisponiveis(planoUsuario).length > 0 ? (
            <>
              <option value="tipologia">Por tipologia</option>
              <option value="area">Por intervalo de área</option>
              <option value="cidades">Por cidade</option>
            </>
          ) : (
            <>
              <option value="area">Por intervalo de área</option>
              <option value="cidades">Por cidade</option>
            </>
          )}
        </select>
      </div>

      <div className="graficos-container">
        <UnidadeGrafico titulo="Ofertadas" dados={dadosAtuais.ofertadas} tipo={dropdownValue} />
        <UnidadeGrafico titulo="Vendidas" dados={dadosAtuais.vendidas} tipo={dropdownValue} />
        <UnidadeGrafico titulo="Estoque" dados={dadosAtuais.estoque} tipo={dropdownValue} />
      </div>
    </div>
  );
}
